// extracted by css-extract-rspack-plugin
export default {"menu":"ES6Eau","menuItem":"ASOSff","login":"cR4Fi1","home":"E_QPJN","bgm":"NCXq5F","off":"nkcUWy"};